import ToolSearch from './ToolSearch';
import './ToolSearch.scss';

export default ToolSearch;